import React, {
    useEffect,
    useMemo,
    useState
} from 'react';


import {
    useNavigate
} from 'react-router-dom';


import {
    useDispatch,
    useSelector
} from 'react-redux';


import HeaderUno
    from '../Metodos/Compartidos/HeaderUno';

import HeaderDos
    from '../Metodos/Compartidos/HeaderDos';

import {
    BotonEditarPaciente
} from '../Css/StyledPacienteResumen';

import useConfigAuth
    from '../../Hooks/useConfigAuth';


import {
    activarMetodoAction,
    darDeBajaMetodoAction
} from '../../actions/gestionarMetodoActions';


import {
    cargarPacientesAction
} from '../../actions/cargarPacientesActions';


import {
    estadoCorrectoInitialAction
} from '../../actions/resetStoreActions';


import {

    ContenedorGestionMetodo,

    TarjetaGestionMetodo,

    EncabezadoGestionMetodo,
    TituloGestionMetodo,
    EstadoGestionMetodo,

    TextoGestionMetodo,

    ResumenCupos,
    DatoCupo,
    ValorCupo,

    AvisoGestionMetodo,

    AccionesGestionMetodo,

    BotonActivarMetodo,
    BotonDarBajaMetodo,

    TextoSinPaciente

} from '../Css/StyledGestionarMetodo';


/*
========================================
GESTIONAR MÉTODO
========================================

Esta pantalla queda dedicada solamente
a la gestión del acceso al Método YÖGEN.

La creación de cuenta del paciente y
las solicitudes de vinculación se gestionan
desde DatosPaciente.
*/

const GestionarMetodo = () => {

    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    /*
    ========================================
    REDUX
    ========================================
    */

    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const pacientes =
        useSelector(
            state =>
                state
                    .informacion
                    .lista_pacientes
        );


    const correcto =
        useSelector(
            state =>
                state.estado.correcto
        );


    const cantidad_suscripciones =
        useSelector(
            state =>
                state.usuario
                    .cantidad_suscripcion
        );


    /*
    ========================================
    PACIENTE ACTUAL
    ========================================
    */

    const paciente =
        useMemo(
            () => {

                if (
                    !Array.isArray(
                        pacientes
                    )
                ) {

                    return null;

                }


                return pacientes.find(
                    item =>
                        item.id_paciente ===
                        id_paciente
                ) || null;

            },
            [
                pacientes,
                id_paciente
            ]
        );


    /*
    ========================================
    PROCESANDO
    ========================================
    */

    const [
        procesando,
        setProcesando
    ] = useState(false);


    /*
    ========================================
    CUPOS
    ========================================
    */

    const cantidadSuscriptos =
        useMemo(
            () => {

                if (
                    !Array.isArray(
                        pacientes
                    )
                ) {

                    return 0;

                }


                return pacientes.filter(
                    item =>
                        item.servicio ===
                        'Método Yögen'
                ).length;

            },
            [
                pacientes
            ]
        );


    const cantidadTotal =
        Number(
            cantidad_suscripciones ||
            0
        );


    const suscripcionesRestantes =
        Math.max(
            cantidadTotal -
            cantidadSuscriptos,
            0
        );


    /*
    ========================================
    ACTIVAR MÉTODO
    ========================================
    */

    const activarMetodo =
        event => {

            event.preventDefault();


            if (
                !paciente ||
                procesando
            ) {

                return;

            }


            setProcesando(
                true
            );


            dispatch(
                activarMetodoAction({

                    config,

                    payload: {

                        id_paciente:
                            paciente.id_paciente

                    }

                })
            );

        };


    /*
    ========================================
    DAR DE BAJA
    ========================================
    */

    const darDeBaja =
        event => {

            event.preventDefault();


            if (
                !paciente ||
                procesando
            ) {

                return;

            }


            setProcesando(
                true
            );


            dispatch(
                darDeBajaMetodoAction({

                    config,

                    payload: {

                        id_paciente:
                            paciente.id_paciente

                    }

                })
            );

        };


    /*
    ========================================
    ACTUALIZAR DESPUÉS DE UNA ACCIÓN
    ========================================
    */

    useEffect(
        () => {

            if (
                !correcto
            ) {

                return;

            }


            const actualizar =
                async () => {

                    await dispatch(
                        cargarPacientesAction({

                            config

                        })
                    );


                    dispatch(
                        estadoCorrectoInitialAction()
                    );


                    navigate(
                        '/escritorio/pacientes'
                    );

                };


            actualizar();


            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            correcto
        ]
    );


    /*
    ========================================
    PACIENTE NO DISPONIBLE
    ========================================
    */

    if (
        !paciente
    ) {

        return (

            <>

                <HeaderUno />


                <HeaderDos

                    link="/escritorio/pacientes/paciente"

                    componente="Gestionar Método"

                    paciente={
                        true
                    }

                />


                <ContenedorGestionMetodo>

                    <TarjetaGestionMetodo>

                        <TextoSinPaciente>

                            No se encontró la información
                            del paciente seleccionado.

                        </TextoSinPaciente>

                    </TarjetaGestionMetodo>

                </ContenedorGestionMetodo>

            </>

        );

    }


    const {

        servicio,

        bloqueo_metodo

    } = paciente;


    /*
    ========================================
    RENDER
    ========================================
    */

    return (

        <>

            <HeaderUno />


            <HeaderDos

                link="/escritorio/pacientes/paciente"

                componente="Gestionar Método"

                paciente={
                    true
                }

            />


            <ContenedorGestionMetodo>


                {/* =================================
                    SOLO ADMINISTRATIVO
                ================================== */}

                {
                    servicio ===
                    'Solo Administrativo' && (

                        <TarjetaGestionMetodo>


                            <EncabezadoGestionMetodo>

                                <TituloGestionMetodo>

                                    Método YÖGEN

                                </TituloGestionMetodo>


                                <EstadoGestionMetodo

                                    $estado="administrativo"

                                >

                                    Solo administrativo

                                </EstadoGestionMetodo>

                            </EncabezadoGestionMetodo>


                            <TextoGestionMetodo>

                                Para utilizar las actividades
                                de Método YÖGEN, el paciente
                                primero debe contar con su
                                usuario vinculado.

                            </TextoGestionMetodo>


                            <AvisoGestionMetodo>

                                La creación de la cuenta o la
                                solicitud de vinculación se
                                gestiona desde la sección
                                <strong>
                                    {' '}Datos del paciente
                                </strong> (Editar perfil).

                                Cuando ese proceso finalice,
                                el paciente aparecerá como
                                <strong>
                                    {' '}Apto para Método
                                </strong>.

                            </AvisoGestionMetodo>


                            <AccionesGestionMetodo>

                                <BotonEditarPaciente

                                    to="/escritorio/pacientes/paciente/datos"

                                >

                                    Ir a Editar perfil

                                </BotonEditarPaciente>

                            </AccionesGestionMetodo>


                        </TarjetaGestionMetodo>

                    )
                }


                {/* =================================
                    APTO PARA MÉTODO
                ================================== */}

                {
                    servicio ===
                    'Apto para Método' && (

                        <TarjetaGestionMetodo>


                            <EncabezadoGestionMetodo>

                                <TituloGestionMetodo>

                                    Activar Método YÖGEN

                                </TituloGestionMetodo>


                                <EstadoGestionMetodo

                                    $estado="apto"

                                >

                                    Apto para Método

                                </EstadoGestionMetodo>

                            </EncabezadoGestionMetodo>


                            <TextoGestionMetodo>

                                El paciente ya tiene su
                                usuario correctamente
                                vinculado y puede comenzar
                                a utilizar Método YÖGEN.

                            </TextoGestionMetodo>


                            <ResumenCupos>


                                <DatoCupo>

                                    Cupos contratados

                                    <ValorCupo>

                                        {
                                            cantidadTotal
                                        }

                                    </ValorCupo>

                                </DatoCupo>


                                <DatoCupo>

                                    En uso

                                    <ValorCupo>

                                        {
                                            cantidadSuscriptos
                                        }

                                    </ValorCupo>

                                </DatoCupo>


                                <DatoCupo>

                                    Disponibles

                                    <ValorCupo>

                                        {
                                            suscripcionesRestantes
                                        }

                                    </ValorCupo>

                                </DatoCupo>


                            </ResumenCupos>


                            {
                                bloqueo_metodo > 0 && (

                                    <AvisoGestionMetodo>

                                        Este paciente se
                                        encuentra bloqueado
                                        temporalmente.

                                        Podrá volver a
                                        activar Método YÖGEN
                                        dentro de{' '}

                                        <strong>

                                            {
                                                bloqueo_metodo
                                            } {
                                                bloqueo_metodo === 1
                                                    ?
                                                    'día'
                                                    :
                                                    'días'
                                            }

                                        </strong>.

                                    </AvisoGestionMetodo>

                                )
                            }


                            {
                                suscripcionesRestantes ===
                                0 && (

                                    <AvisoGestionMetodo>

                                        Actualmente no tenés
                                        cupos disponibles para
                                        activar otro paciente.

                                    </AvisoGestionMetodo>

                                )
                            }


                            <AccionesGestionMetodo>


                                <BotonActivarMetodo

                                    type="button"

                                    disabled={

                                        procesando ||

                                        suscripcionesRestantes ===
                                        0 ||

                                        Number(
                                            bloqueo_metodo ||
                                            0
                                        ) > 0

                                    }

                                    onClick={
                                        activarMetodo
                                    }

                                >

                                    {
                                        procesando
                                            ?
                                            'Activando...'
                                            :
                                            'Activar Método YÖGEN'
                                    }

                                </BotonActivarMetodo>


                            </AccionesGestionMetodo>


                        </TarjetaGestionMetodo>

                    )
                }


                {/* =================================
                    MÉTODO ACTIVO
                ================================== */}

                {
                    servicio ===
                    'Método Yögen' && (

                        <TarjetaGestionMetodo>


                            <EncabezadoGestionMetodo>

                                <TituloGestionMetodo>

                                    Método YÖGEN

                                </TituloGestionMetodo>


                                <EstadoGestionMetodo

                                    $estado="activo"

                                >

                                    Método activo

                                </EstadoGestionMetodo>

                            </EncabezadoGestionMetodo>


                            <TextoGestionMetodo>

                                Este paciente está utilizando
                                actualmente uno de tus cupos
                                de Método YÖGEN.

                            </TextoGestionMetodo>


                            <AvisoGestionMetodo

                                $advertencia={
                                    true
                                }

                            >

                                Si das de baja al paciente,
                                no podrás volver a activar
                                Método YÖGEN para este usuario
                                durante un período de{' '}

                                <strong>
                                    30 días
                                </strong>.

                            </AvisoGestionMetodo>


                            <AccionesGestionMetodo>


                                <BotonDarBajaMetodo

                                    type="button"

                                    disabled={
                                        procesando
                                    }

                                    onClick={
                                        darDeBaja
                                    }

                                >

                                    {
                                        procesando
                                            ?
                                            'Procesando...'
                                            :
                                            'Dar de baja Método YÖGEN'
                                    }

                                </BotonDarBajaMetodo>


                            </AccionesGestionMetodo>


                        </TarjetaGestionMetodo>

                    )
                }


            </ContenedorGestionMetodo>

        </>

    );

};


export default GestionarMetodo;